module.exports = __webpack_public_path__ + "static/media/test14_1.07c54399.png";